require('./angular-touch');
module.exports = 'ngTouch';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-touch/index.js
// module id = 233
// module chunks = 6